module.exports = __webpack_public_path__ + "static/media/haymosApp.e49bca85.png";